import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';

import NewModal from 'components/Managers/Teams/Views/New/Index';

export default function Index() {
  const [showNewModal, setShowNewModal] = useState(false);

  return (
    <section>
      <Row className="mb-3">
        <Col>
          <h1>Teams</h1>
        </Col>

        <Col xs="auto">
          <Button onClick={() => setShowNewModal(true)}>
            New Team
          </Button>
        </Col>
      </Row>

      <NewModal
        show={showNewModal}
        onCloseClick={() => setShowNewModal(false)}
      />
    </section>
  );
}
